import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Col, Row } from "reactstrap";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useState } from "react";
import { useEffect } from "react";
import API from "../../api";

const ProductItem = ({ title, description, subtitle, text, img }) => {
  const { t } = useTranslation();
  const lang = useSelector((state) => state.lang.lang);
  const swiperRef = useRef(null);

  const subtitlesArray = Array.isArray(subtitle) ? subtitle : [subtitle];
  const textsArray = Array.isArray(text) ? text : [text];

  const [currentSubtitle, setCurrentSubtitle] = useState(subtitlesArray[0]);
  const [currentText, setCurrentText] = useState(textsArray[0]);

  useEffect(() => {
    setCurrentSubtitle(subtitlesArray[0]);
    setCurrentText(textsArray[0]);
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slideTo(0);
    }
  }, [lang, subtitlesArray, textsArray]);

  const handleSlideChange = (swiper) => {
    const activeIndex = swiper.realIndex;
    setCurrentSubtitle(subtitlesArray[activeIndex]);
    setCurrentText(textsArray[activeIndex]);
  };

  return (
    <div>
      <Row>
        <Col xs={12} sm={12} md={6} lg={6} xl={6} className="mb-4 text-col">
          <div className="mt-5">
            <div>
              <strong className=" f32 fw500 color1">{title}</strong>
            </div>
            <div className="mt-2">
              <span className="f16 fw400 color1">{description}</span>
            </div>
          </div>
          <div className="mt-5">
            <div>
              <strong className="f20 fw600 color6">{currentSubtitle}</strong>
            </div>
            <div className="mt-2">
              <span className="f16 fw400 color1">{currentText}</span>
            </div>
          </div>

          {/* <div className='mt-3'>
                        <Link to={lang === "tr" ? "/urun-ailesi" : "/product-family-detail"} className='text-decoration-none'>
                            <Button color='primary'>
                                <div>{t("view_brochure")}</div>
                                <div className='ml-2'><FaChevronRight size={13} /></div>
                            </Button>
                        </Link>
                    </div> */}
        </Col>

        <Col xs={12} sm={12} md={6} lg={6} xl={6} className="mb-4 image-col">
          <Swiper
            ref={swiperRef}
            modules={[Navigation, Pagination]}
            slidesPerView={1}
            pagination={{ clickable: true }}
            onSlideChange={handleSlideChange}
            navigation
            loop={img.length > 1}
            allowTouchMove={true}
            draggable={true}
            noSwiping={img.length === 1}
          >
            {img.map((img, index) => (
              <SwiperSlide key={index}>
                <img
                  src={`${API.BASE}${img}`}
                  alt={`Product image ${index + 1}`}
                />
              </SwiperSlide>
            ))}

            {/* <SwiperSlide>
                        <img src={img} alt='' />
                    </SwiperSlide> */}
          </Swiper>
        </Col>
      </Row>

      <hr className="full-width-separator" />
    </div>
  );
};

export default ProductItem;
